module.exports = __webpack_public_path__ + "assets/images/arrow-refresh.9b9dd4be8894580bab4c0d89c95e0538.svg";